import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../estilo.css';

export default function Inicio() {
  const { t } = useTranslation();
  const robots = t('home.robots.items', { returnObjects: true });
  const aboutIntro = t('home.about.intro', { returnObjects: true });
  const aboutBlocks = t('home.about.blocks', { returnObjects: true });
  const ctaParagraphs = t('home.about.ctaParagraphs', { returnObjects: true });

  return (
    <div>
      {/* HERO / TOPO */}
      <div className="hero-banner">
        <img
          src={require('../img/site_principal_transparente.webp')}
          srcSet={`${require('../img/site_principal_transparente-640.webp')} 640w, ${require('../img/site_principal_transparente-1280.webp')} 1280w, ${require('../img/site_principal_transparente.webp')} 1672w`}
          sizes="100vw"
          width="1672"
          height="941"
          fetchpriority="high"
          decoding="async"
          alt="Quantum Trades"
          className="hero-banner-image"
        />

      </div>
      <div
        className="jumbotron text-center legacy-hero"
        style={{
          background:
            'radial-gradient(circle at top, #61527a 0%, #443c56 52%, #322943 100%)',
          padding: '80px 20px 70px',
        }}
      >
        <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
          <div className="row" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            <div className="col-sm-6" style={{ marginBottom: '20px' }}>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '8px 14px',
                  borderRadius: '999px',
                  background: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  color: '#d7fff7',
                  fontSize: '13px',
                  fontWeight: 700,
                  letterSpacing: '0.3px',
                  marginBottom: '20px',
                }}
              >
                <span
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: '#42a89c',
                    boxShadow: '0 0 10px rgba(66,168,156,0.6)',
                  }}
                />
                {t('home.hero.badge')}
              </div>

              <h1
                style={{
                  fontSize: '46px',
                  lineHeight: 1.1,
                  margin: '0 0 14px 0',
                  color: '#ffffff',
                  textAlign: 'left',
                }}
              >
                Quantum Trades
              </h1>

              <h3
                style={{
                  fontSize: '24px',
                  fontWeight: 500,
                  color: '#d8d1ff',
                  margin: '0 0 20px 0',
                  textAlign: 'left',
                }}
              >
                {t('home.hero.headline')}
              </h3>

              <p
                style={{
                  maxWidth: '620px',
                  margin: 0,
                  fontSize: '17px',
                  lineHeight: 1.7,
                  color: '#f3f1ff',
                  textAlign: 'left',
                  paddingTop: 0,
                }}
              >
                {t('home.hero.description')}
              </p>

              <p
                style={{
                  maxWidth: '620px',
                  marginTop: '14px',
                  fontSize: '15px',
                  lineHeight: 1.7,
                  color: '#e5ddff',
                  textAlign: 'left',
                }}
              >
                {t('home.hero.supporting')}
              </p>

              <div
                style={{
                  marginTop: '26px',
                  display: 'flex',
                  gap: '12px',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                }}
              >
                <Link to="/cadastro" className="btn btn-primary btn-lg">
                  {t('home.hero.createAccount')}
                </Link>
                <Link to="/planos" className="btn btn-default btn-lg">
                  {t('home.hero.viewPlans')}
                </Link>
              </div>

              <div
                style={{
                  marginTop: '22px',
                  display: 'flex',
                  gap: '22px',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                }}
              >
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>3</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>{t('home.hero.availableRobots')}</div>
                </div>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>MT5</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>{t('home.hero.mt5Compatible')}</div>
                </div>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>{t('home.hero.markets')}</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>{t('home.hero.differentScenarios')}</div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 text-center">
              <div
                style={{
                  position: 'relative',
                  maxWidth: '500px',
                  margin: '0 auto',
                  padding: '26px',
                  borderRadius: '28px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.10)',
                  boxShadow:
                    '0 24px 60px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.06)',
                  backdropFilter: 'blur(6px)',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    inset: '18px',
                    borderRadius: '22px',
                    background:
                      'radial-gradient(circle at top right, rgba(66,168,156,0.14), transparent 42%), radial-gradient(circle at bottom left, rgba(132,110,143,0.18), transparent 40%)',
                    pointerEvents: 'none',
                  }}
                />

                <div
                  style={{
                    position: 'relative',
                    borderRadius: '22px',
                    padding: '18px',
                    background: 'linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))',
                  }}
                >
                  <img
                    src={require('../img/Quantum1.png')}
                    alt="Quantum Trades"
                    className="responsive-image"
                    style={{
                      maxWidth: '100%',
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                      borderRadius: '18px',
                      boxShadow: '0 14px 35px rgba(0,0,0,0.22)',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="robos" className="robots-section">
        <div className="robots-inner">
          <div className="robots-header">
            <p>{t('home.robots.eyebrow')}</p>
            <h2>{t('home.robots.title')}</h2>
            <div className="robots-intro">{t('home.robots.intro')}</div>
          </div>

          <div className="robots-grid">
            {Array.isArray(robots) && robots.map((robot) => (
              <article className="robot-card" key={robot.name}>
                <h3>{robot.name}</h3>
                <p>{robot.description}</p>
                <ul>
                  {robot.features.map((feature) => <li key={feature}>{feature}</li>)}
                </ul>
              </article>
            ))}
          </div>

          <div className="robots-openbox-note" role="note">
            <p>{t('home.robots.openBoxNote')}</p>
            <p className="robots-openbox-resources">
              {t('home.robots.openBoxResources.intro')}{' '}
              <Link to="/portifolio">{t('home.robots.openBoxResources.portfolio')}</Link>{' '}
              {t('home.robots.openBoxResources.or')}{' '}
              <a
                href="https://www.youtube.com/@QuantumTradesBR"
                target="_blank"
                rel="noreferrer"
              >
                {t('home.robots.openBoxResources.youtube')}
              </a>
              {t('home.robots.openBoxResources.end')}
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO SOBRE / ID PARA O MENU */}
      <div id="about" className="container-fluid bg-quant">
        <div className="about-shell">
          <div className="about-intro">
            <h2>{t('home.about.title')}</h2>
            {Array.isArray(aboutIntro) && aboutIntro.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>

          <div className="about-grid">
            {Array.isArray(aboutBlocks) && aboutBlocks.map((block) => (
              <div className="about-block" key={block.title}>
                <h3>{block.title}</h3>
                {block.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                {Array.isArray(block.features) && (
                  <ul>
                    {block.features.map((feature) => <li key={feature}>{feature}</li>)}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="row" style={{ marginTop: '30px' }}>
          <div className="col-sm-12 text-center">
            <h3>{t('home.about.ctaTitle')}</h3>
            {Array.isArray(ctaParagraphs) && ctaParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <Link to="/planos" className="btn btn-primary btn-lg">
              {t('home.about.cta')}
            </Link>
          </div>
        </div>
      </div>

      <section className="platform-section">
        <div className="platform-inner">
          <img
            src={require('../img/MetaTrader5.png')}
            alt="MetaTrader 5"
            className="platform-logo"
          />
          <div>
            <h3>MetaTrader 5</h3>
            <p>{t('home.about.platform')}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
